import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function CookieBanner() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) setOpen(true);
  }, []);
  const accept = () => { localStorage.setItem("cookie_consent", "accepted"); setOpen(false); };
  if (!open) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 bg-white border border-border rounded-xl shadow-lg p-5 flex flex-col gap-3" data-testid="cookie-banner">
      <div className="text-sm text-foreground/80">
        Utilizziamo solo <b>cookie tecnici</b> necessari al funzionamento del sito e alla gestione della tua sessione di accesso. Nessun tracciamento pubblicitario.
        <div className="mt-1"><Link to="/cookie" className="text-primary underline text-sm">Cookie Policy</Link> · <Link to="/privacy" className="text-primary underline text-sm">Privacy</Link></div>
      </div>
      <div className="flex justify-end">
        <Button size="sm" onClick={accept} className="rounded-full" data-testid="cookie-accept-btn">Ho capito</Button>
      </div>
    </div>
  );
}
